import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Tabs,
  Tab,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SettingsPanel from './SettingsPanel';
import StoriesPanel from './StoriesPanel';
import CategoriesPanel from './CategoriesPanel';
import StylingPanel from './StylingPanel';
import TabPanel from './shared/TabPanel';
import categoryService from '../../services/categoryService';
import storyEventService from '../../services/storyEventService';
import stylingService from '../../services/stylingService';

const styles = {
  dialogContent: {
    padding: 0,
    height: '70vh',
    overflowY: 'auto'
  }
};

const AdminDialog = ({ 
  open, 
  onClose, 
  settings, 
  onSettingsChange, 
  onAddStory, 
  onEditStory, 
  onDeleteStory,
  activeTab = 0,
  initialEditingStory = null
}) => {
  const [currentTab, setActiveTab] = useState(activeTab);
  const [categories, setCategories] = useState([]);
  const [storyEvents, setStoryEvents] = useState([]);
  const [stylings, setStylings] = useState([]);
  
  // Handle authentication errors
  const handleAuthError = (error) => {
    if (error.response && error.response.status === 401) {
      alert('Oturum süresi dolmuş. Lütfen tekrar giriş yapın.');
    }
  };

  // Fetch data from server
  useEffect(() => {
    const fetchData = async () => {
      if (settings && settings._id) {
        try {
          const categoriesData = await categoryService.getCategories(settings._id);
          setCategories(categoriesData);
          
          const storiesData = await storyEventService.getStoryEvents(settings._id);
          setStoryEvents(storiesData);
          
          const stylingsData = await stylingService.getStylings(settings._id);
          setStylings(stylingsData);
        } catch (error) {
          console.error('Error fetching data:', error);
          handleAuthError(error);
        }
      }
    };
    
    fetchData();
  }, [settings]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Callback functions for child components
  const refreshCategories = async () => {
    try {
      const data = await categoryService.getCategories(settings._id);
      setCategories(data);
    } catch (error) {
      console.error('Error fetching categories:', error);
      handleAuthError(error);
    }
  };

  const refreshStories = async () => {
    try {
      const data = await storyEventService.getStoryEvents(settings._id);
      setStoryEvents(data);
    } catch (error) {
      console.error('Error fetching stories:', error);
      handleAuthError(error);
    }
  };

  const refreshStylings = async () => {
    try {
      const data = await stylingService.getStylings(settings._id);
      setStylings(data);
    } catch (error) {
      console.error('Error fetching stylings:', error);
      handleAuthError(error);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2, pb: 1 }}>
        <Typography variant="h6">Zaman Çizelgesi Yönetimi</Typography>
        <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3 }}>
        <Tabs 
          value={currentTab} 
          onChange={handleTabChange} 
          aria-label="admin tabs"
        >
          <Tab label="Ayarlar" />
          <Tab label="Hikayeler" />
          <Tab label="Kategoriler" />
          <Tab label="Stiller" />
        </Tabs>
      </Box>
      
      <DialogContent dividers sx={styles.dialogContent}>
        <TabPanel value={currentTab} index={0}>
          <SettingsPanel 
            settings={settings} 
            onSettingsChange={onSettingsChange}
          />
        </TabPanel>
        
        <TabPanel value={currentTab} index={1}>
          <StoriesPanel 
            settings={settings}
            categories={categories}
            stylings={stylings}
            storyEvents={storyEvents}
            refreshStories={refreshStories}
            initialEditingStory={initialEditingStory}
            onDeleteStory={onDeleteStory}
          />
        </TabPanel>
        
        <TabPanel value={currentTab} index={2}>
          <CategoriesPanel 
            settings={settings}
            categories={categories}
            refreshCategories={refreshCategories}
          />
        </TabPanel>

        <TabPanel value={currentTab} index={3}>
          <StylingPanel
            settings={settings}
            stylings={stylings}
            refreshStylings={refreshStylings}
          />
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};

export default AdminDialog;